import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import TestTimer from "./TestTimer";
import "../../styles/testHeader.css";

import CalculatorIcon from "./icons/CalculatorIcon";
import ReferenceIcon from "./icons/ReferenceIcon";

/* ---------- Tab ---------- */

const HeaderTab = ({
  icon,
  label,
  active,
  onClick,
  disabled,
  labelOffsetY = 0,
}) => (
  <Box
    onClick={disabled ? undefined : onClick}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      cursor: disabled ? "default" : "pointer",
      opacity: disabled ? 0.4 : 1,
      px: 1.75,
      userSelect: "none",
    }}
  >
    <IconButton
      disableRipple
      disabled={disabled}
      sx={{ color: "#111827", mb: -1, userSelect: "none" }}
    >
      {icon}
    </IconButton>

    <Typography
      variant="caption"
      sx={{
        fontWeight: 600,
        userSelect: "none",
        textDecoration: active ? "underline" : "none",
        textDecorationThickness: "2px",
        textUnderlineOffset: "4px",
        transform: `translateY(${labelOffsetY}px)`,
      }}
    >
      {label}
    </Typography>
  </Box>
);

/* ---------- Header ---------- */

const TestHeader = ({
  title,
  section,
  timeRemaining,
  isTutor = false,
  onEditQuestion,
  onExit,
  onToggleCalculator,
  onToggleReference,
  isCalculatorOpen,
  isReferenceOpen,
}) => {
  const isMath = section?.toLowerCase() === "math";

  return (
    <div className="test-header-wrapper">
      <div className="test-header">
        {/* LEFT  ▸ packet / section */}
        <Box className="test-header-left">
          <div className="test-header-packet">{title}</div>
          <div className="test-header-subtitle">{`SAT • ${section}`}</div>
        </Box>

        {/* CENTER ▸ timer OR edit button */}
        <Box className="test-header-center">
          {isTutor ? (
            <Button
              variant="contained"
              size="small"
              sx={{
                borderRadius: "25px",
                py: 1,
                px: 2.75,
                fontWeight: 600,
                textTransform: "none"
              }}
              onClick={onEditQuestion}
            >
              Edit Question
            </Button>
          ) : (
            <TestTimer timeRemaining={timeRemaining} />
          )}
        </Box>

        {/* RIGHT  ▸ calc / ref / exit */}
        <Box className="test-header-right">
          {isMath && (
            <HeaderTab
              icon={<CalculatorIcon />}
              label="Calculator"
              active={isCalculatorOpen}
              onClick={onToggleCalculator}
            />
          )}

          {isMath && (
            <HeaderTab
              icon={<ReferenceIcon />}
              label="Reference"
              active={isReferenceOpen}
              onClick={onToggleReference}
              labelOffsetY={2.1}
            />
          )}

          <Button
            onClick={onExit}
            variant="contained"
            sx={{
              borderRadius: "25px",
              py: 1,
              px: 2.75,
              fontWeight: 600,
              textTransform: "none",
              ml: 2,
            }}
          >
            Exit Test
          </Button>
        </Box>
      </div>

      <div className="test-header-dashed" />
    </div>
  );
};

export default TestHeader;
